// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { RadioStyle } from "@insite/mobius/Radio";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { xBaseTheme } from "@werner/XDL/types";
import color from "@werner/XDL/Utilities/color";
import { css } from "styled-components";

const generalStyles = css`
    & + label {
        margin-left: 0;
        margin-right: 30px;
    }
    & + label::before {
        width: 22px;
        height: 22px;
        border-color: ${color("common.ui1")};
        margin-right: 6px;
    }
    &:checked + label::after {
        width: 14px;
        height: 14px;
        left: 4px;
        top: 4px;
    }
    &:focus + label::before {
        box-shadow: none;
        border: 2px solid ${color("primary")};
    }
`;

const hoverStyle = css`
    &:hover:not(:disabled) + label::before,
    &:hover:checked:not(:disabled) + label::before {
        border: 2px solid ${color("common.ui3")};
    }
    &:hover:not(:disabled) + label::after,
    &:hover:checked:not(:disabled) + label::after {
        background: ${color("common.ui3")};
    }
    &:hover:not(:disabled) + label {
        cursor: pointer;
    }
`;

const checkedStyle = css`
    &:checked:not(:disabled) + label::before {
        border: 2px solid ${color("primary")} !important;
        background: ${color("common.white")} !important;
    }
    &:checked:not(:disabled) + label::after {
        background: ${color("primary")} !important;
    }
`;

const disabledStyle = css`
    &:disabled + label {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export default {
    defaultProps: {
        mergeCss: true,
        typographyProps: {
            mergeCss: true,
            size: 15,
            color: "text.main",
            css: css`
                letter-spacing: 0;
                line-height: 18px;
                user-select: none;
            `,
        },
        css: css`
            input {
                margin-left: 0px;
                margin-right: 0px;
                margin-top: 0px;
                width: 22px;
                height: 22px;
                display: none;
                ${generalStyles}
                ${hoverStyle}
                ${checkedStyle}
                ${disabledStyle}
            }
        `,
    },
    groupDefaultProps: {
        mergeCss: true,
        labelProps: {
            variant: "h6",
            size: 14,
            weight: 500,
            css: css`
                margin-bottom: 20px;
                &:empty {
                    display: none;
                }
            `,
        },
        errorProps: {
            variant: "h6",
            size: 14,
            weight: 500,
            css: css`
                &:empty {
                    display: none;
                }
            `,
        },
        css: css`
            & > ${RadioStyle} {
                margin-right: 0;
            }
        `,
    },
} as xBaseTheme["radio"];
